import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "total", "count", "submit"]

  connect() {
    this.update()
  }

  update() {
    const checked = this.checkboxTargets.filter(cb => cb.checked)
    let total = 0
    checked.forEach(cb => { total += parseFloat(cb.dataset.price) || 0 })

    this.totalTarget.textContent = '$' + total.toLocaleString()
    this.countTarget.textContent = checked.length + (checked.length === 1 ? ' service' : ' services') + ' selected'
    this.submitTarget.disabled = checked.length === 0
  }
}
